module.exports = __webpack_public_path__ + "img/bg-minified.322a1e84.svg";